export function hasTouchedFields(obj: Record<string, unknown>): boolean {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  for (const key in obj) {
    // eslint-disable-next-line no-prototype-builtins
    if (obj.hasOwnProperty(key)) {
      if (obj[key] === true) {
        return true;
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        return hasTouchedFields(obj[key] as Record<string, unknown>);
      }
    }
  }

  return false;
}
